import React from 'react';
import { ArrowUpRight, Phone, Clock } from 'lucide-react';
import Reveal from './Reveal';

const WHATSAPP_NUMBER = '393383463712'; // 338 346 3712 con prefisso Italia
const DISPLAY_NUMBER = '+39 338 346 3712';

const buildWaUrl = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

const DEFAULT_MSG =
  'Ciao! Ho visto il tuo sito B-WEB. Vorrei avere informazioni per creare un sito web per la mia attività.';

export default function Contact() {
  return (
    <section id="contatti" className="relative py-24 md:py-32 bg-[#f0ece2]">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <Reveal variant="fade">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-8 h-px bg-[#1e6cb0]" />
              <span className="text-[12px] tracking-[0.2em] uppercase font-semibold text-[#1e6cb0]">
                Scrivimi su WhatsApp
              </span>
              <span className="w-8 h-px bg-[#1e6cb0]" />
            </div>
          </Reveal>
          <Reveal as="h2" variant="up" delay={120} duration={850} className="heading-mega text-[42px] md:text-[68px] text-neutral-900">
            Un messaggio.<br />
            <span className="text-[#1e6cb0]">Niente moduli</span> infiniti.
          </Reveal>
          <Reveal as="p" variant="up" delay={280} className="mt-6 max-w-xl mx-auto text-[16px] leading-relaxed text-neutral-600">
            Sono uno studente di Biella e costruisco siti web usando l'intelligenza artificiale.
            Niente call center, niente moduli da compilare in dieci passaggi: <span className="font-semibold text-neutral-900">scrivimi un messaggio
            su WhatsApp</span> e ti rispondo io di persona.
          </Reveal>
        </div>

        <Reveal variant="up" delay={150} duration={900}>
          <div className="bg-white rounded-3xl border border-black/5 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.15)] p-8 md:p-12 max-w-2xl mx-auto">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-2xl bg-[#25d366]/10 flex items-center justify-center">
                {/* WhatsApp logo as inline SVG */}
                <svg viewBox="0 0 32 32" className="w-6 h-6" fill="#25d366" aria-hidden="true">
                  <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.715.888.817 0 2.434-.515 2.762-1.318.13-.33.13-.602.07-.66-.06-.13-.231-.20-.471-.314z"/>
                  <path d="M16.045 0c-8.844 0-16 7.156-16 16 0 2.812.731 5.46 2.020 7.766L0 32l8.367-2.205c2.21 1.196 4.74 1.873 7.39 1.873 8.846 0 16.002-7.156 16.002-16C31.76 7.156 24.604 0 16 0zm0 28.842c-2.42 0-4.696-.731-6.612-1.985l-4.616 1.218 1.234-4.504c-1.4-1.992-2.232-4.42-2.232-7.057 0-6.787 5.518-12.305 12.305-12.305s12.305 5.518 12.305 12.305c0 6.788-5.518 12.328-12.384 12.328z" opacity=".95"/>
                </svg>
              </div>
              <div>
                <div className="font-display text-[20px] font-extrabold text-neutral-900">WhatsApp diretto</div>
                <div className="text-[13px] text-neutral-500">Risposta in giornata, di persona</div>
              </div>
            </div>

            <div className="rounded-2xl bg-neutral-50 border border-black/5 p-4 mb-5">
              <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-neutral-500 mb-2">
                Messaggio precompilato
              </div>
              <p className="text-[14px] leading-relaxed text-neutral-700 italic">
                &ldquo;{DEFAULT_MSG}&rdquo;
              </p>
            </div>

            <a
              href={buildWaUrl(DEFAULT_MSG)}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full md:w-auto inline-flex items-center justify-center gap-2 bg-[#25d366] hover:bg-[#1fb855] text-white px-7 py-4 rounded-full font-semibold text-[16px] transition-colors shadow-[0_14px_40px_-10px_rgba(37,211,102,0.55)]"
            >
              Apri WhatsApp <ArrowUpRight className="w-4 h-4" />
            </a>

            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-[14px]">
              <a
                href={`tel:+${WHATSAPP_NUMBER}`}
                className="inline-flex items-center gap-2 text-neutral-700 hover:text-[#1e6cb0] transition-colors font-semibold"
              >
                <Phone className="w-4 h-4 text-[#1e6cb0]" />
                {DISPLAY_NUMBER}
              </a>
              <span className="inline-flex items-center gap-2 text-neutral-500">
                <Clock className="w-4 h-4" />
                Tutti i giorni · 8:00–22:00
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
